import { createTRPCUntypedClient, httpLink, splitLink, unstable_httpSubscriptionLink, } from "@trpc/client";
import SuperJSON from "superjson";
import { parseURL, stringifyParsedURL } from "ufo";
const updatePath = (url) => {
    const parsed = parseURL(url);
    parsed.pathname = "/" + parsed.pathname.replace(/(^\/|\/$)/g, "").replace(/\./g, "/") + "/";
    return stringifyParsedURL(parsed);
};
let client;
export function getRPCClient() {
    if (env.rpcEnabled) {
        if (!client) {
            // @ts-ignore
            const endpoint = env.serverless ? "/" : (window.SERVERLESS_ENDPOINT ?? "/");
            client = createTRPCUntypedClient({
                links: [
                    splitLink({
                        condition: (op) => op.type === "subscription",
                        true: unstable_httpSubscriptionLink({
                            url: endpoint,
                            transformer: SuperJSON,
                        }),
                        false: httpLink({
                            url: endpoint,
                            fetch: (url, opts) => {
                                return fetch(updatePath(url), {
                                    ...opts,
                                    credentials: "omit",
                                });
                            },
                            transformer: SuperJSON,
                        }),
                    }),
                ],
            });
        }
    }
    return client;
}
